import React, {useEffect, useState, useImperativeHandle, forwardRef} from 'react'
import { Alert, Modal, Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap'
import { getRelationShip } from '../../redux/relationship/actions'
import { useDispatch, useSelector } from 'react-redux'
import { getEmergencyContact, 
  saveEmergencyContact, 
  editEmergencyContact, 
  deleteEmergencyContact } from '../../redux/emergencycontact/actions'
import { requestChangesDependants } from '../../redux/updateDependantsData/actions'
import { requesChangesUserContacts } from '../../redux/updateUserData/actions'
import messages from '../../redux/messages'
import CustomTable from '../../components/CustomTable'
import config from '../../config'
import moment from 'moment'

const EmergencyContactsComponent = (props, ref) => {

  const [edit, setEdit] = useState(false)
  const [index, setIndex] = useState(0)
  const [editItem, setEditItem] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [validated, setValidated] = useState(false)

  const columns = [
    {
      Header: 'Identidad',
      accessor: 'identidad'
    },
    {
      Header: 'Nombre',
      accessor: 'nombre'
    },
    {
      Header: 'Apellidos',
      accessor: 'apellido'
    },
    {
      Header: 'Teléfono',
      accessor: 'telefono',
      Filter: ''
    },
    // {
    //   Header: 'Correo electrónico',
    //   accessor: 'correo',
    //   Filter: ''
    // },
    {
      Header: 'Parentesco',
      //accessor: 'parentesco',
      Filter: '',
      Cell: value => {
        const parent = relationShip.find(item => item.id === value.row.original.parentesco);
        return parent ? parent.nombre : ''
        //return relationShip.length > 0 ? .nombre : '';
      }
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div
        className="btn-group"
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
          <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ]

  //Redux
  const dispatch = useDispatch()
  //EmerContact
  const loading = useSelector(store => store.emergencyContact.loading)
  const data = useSelector(store => store.emergencyContact.emergencyContacts)
  const saveEmergencyContactLoader = useSelector(store => store.emergencyContact.saveLoader)
  //RelationShip
  const relationShip = useSelector(store => store.relationship.relationShip)
  const relationShipLoader = useSelector(store => store.relationship.loading)
  const userInfo = useSelector(store => store.employees.employee)
  //auth
  const userOrg = useSelector((store) => store.auth.userOrg);

  const onAdd = () => {
    setShowModal(true)
    setEdit(false)
    //setLoadingType('modal');
    setValidated(false)
  }

  useImperativeHandle(ref, () => ({
    onAdd
  }))

  const onEdit = (item, index) => {
    setIndex(index)
    setEdit(true)
    setEditItem(item)
    setShowModal(true)
    //setLoadingType('modal');
    setValidated(false)
  }

  useEffect(() => {
    dispatch(getEmergencyContact({
      filter: props.id,
      empleado: props.id
    }, parseInt(props.type)))
  }, [dispatch, props.id, props.type])

  useEffect(() => {
    dispatch(getRelationShip(parseInt(props.type)))
  }, [dispatch])

  const onSubmit = e => {
    e.preventDefault()
    const form = e.currentTarget
    if (form.checkValidity() === false) {
      setValidated(true)
      return
    }

    // const oData = {
    //   nombre: e.target.emerContacName.value,
    //   apellido: e.target.emerContacLastName.value,
		// 	identidad: e.target.emerContacNIdentidad.value,
		// 	telefono: e.target.emerContacPhone.value,
		// 	direccion: e.target.emerContacAddress.value,
		// 	correo: e.target.emerContacEmail.value,
		// 	anotaciones: e.target.emerContacAnt.value,
		// 	genero: e.target.emerContacGender.value,
		// 	parentesco: parseInt(e.target.emerContacRelationShip.value),
		// 	empleado: parseInt(props.id)
    // }
    const oData = {
      nombre: e.target.relativeName.value,
      segundo_apellido: e.target.segundo_apellido.value,
      apellido_soltera: e.target.apellidoSolt.value,
			identidad: e.target.relativeNIdentidad.value,
			subtipo: '7',
      de: moment().format('YYYY-MM-DD'),
      hasta: moment().format('YYYY-MM-DD'),
      fecha_nacimiento: e.target.relativeBday.value,
			secuencia: edit ? editItem.subtipo : '',
      ciudad_nacimiento: e.target.lugarnaci.value,
      pais_nacimiento: e.target.countyofbirt.value, 
      nacionalidad: e.target.countyofbirt.value,
      dependiente: '',
      genero: e.target.relativeGender.value,
      empresa_id: userOrg
    }

    if(props.ect === 1){
      oData.empleado = parseInt(props.id)
      oData.apellido = e.target.primer_apellido.value
      oData.direccion = e.target.dependentRelativesAddress.value
      oData.telefono = e.target.cel.value
      oData.anotaciones = e.target.obs.value
      oData.direccion = e.target.dependentRelativesAddress.value
      oData.parentesco = e.target.relativeRelationShip.value
      if(edit){
        dispatch(editEmergencyContact(oData, editItem.id, index, parseInt(props.type)))
        //setShowModal(false)
      }else{
        dispatch(saveEmergencyContact(oData, parseInt(props.type)))
        e.target.reset()
      }
    }else{
      oData.codigo_empleado = userInfo.codigo
      oData.primer_apellido = e.target.primer_apellido.value
      dispatch(requestChangesDependants(oData, props.showMessagef))
      dispatch(requesChangesUserContacts({codigo_empleado: userInfo.codigo, 
        subtipo: 'AUCE', 
        valor: e.target.cel.value,
        empresa_id: userOrg}, props.showMessagef))
      }
      setShowModal(false)
  }
    
  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteEmergencyContact(id, index, parseInt(props.type)))
    }
  }
  const {paises, genero} = config.aurora

  return (
    <>
      {
        loading ? (
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center" />
          </div>
        ) : data.length > 0 ? (
          <>
            <Card className="border-0">
              <Card.Body className="px-1 px-sm-2">
                <CustomTable
                  columns={columns}
                  data={data} />
              </Card.Body>
            </Card>
          </>
        ) : (
          <Alert variant="info" className="my-4">
            Aún no hay familiares registrados, comienza agregando algunos
          </Alert>
        )
      }
       <Modal
        show={showModal}
        size="lg"
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar Contacto' : 'Agregar contacto'}</Modal.Title>
          </Modal.Header>
          <Modal.Body >
            {/* <Row>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="emerContacName">
                <Form.Label className="ml-2">Nombre completo</Form.Label>
                <Form.Control
                  name="emerContacName"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  defaultValue={edit ? editItem.nombre : null}
                  placeholder="Nombre completo"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="emerContacLastName">
                <Form.Label className="ml-2">Apellidos</Form.Label>
                <Form.Control
                  name="emerContacLastName"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  defaultValue={edit ? editItem.apellido : null}
                  placeholder="Apellidos"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="emerContacNIdentidad">
                <Form.Label className="ml-2">Identidad</Form.Label>
                <Form.Control
                  name="emerContacNIdentidad"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[0-9]{13}"
                  defaultValue={edit ? editItem.identidad : null}
                  placeholder="Identidad"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite una cadena de números de longitud 13
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="emerContacPhone">
                <Form.Label className="ml-2">Teléfono</Form.Label>
                <Form.Control
                  name="emerContacPhone"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[0-9]+"
                  defaultValue={edit ? editItem.telefono : null}
                  placeholder="Teléfono"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} sm="12" md="12" lg="4" controlId="emerContacEmail">
                <Form.Label className="ml-2">Correo empresarial</Form.Label>
                <Form.Control
                  name="emerContacEmail"
                  className="rounded-pill"
                  required
                  type="email"
                  defaultValue={edit ? editItem.correo : null}
                  placeholder="Correo empresarial"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Se requiere un correo valido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="emerContacAnt">
                <Form.Label className="ml-2">Anotaciones</Form.Label>
                <Form.Control
                  name="emerContacAnt"
                  className="rounded-pill"
                  required={!edit}
                  type="text"
                  pattern="[a-zA-Z0-9][a-zA-Z0-9\s]*"
                  defaultValue={edit ? editItem.anotaciones : null}
                  placeholder="Anotaciones"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="emerContacGender">
                <Form.Label className="ml-2">Género</Form.Label>
                <Form.Control
                  as="select"
                  name="emerContacGender"
                  className="rounded-pill"
                  required
                  defaultValue={ edit ? editItem.genero : null }
                  placeholder="Genero">
                    {
                      config.aurora.genero.map(item => (
                        <option key={item.id} value={item.id}>{item.nombre}</option>
                      ))
                    }
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              
              <Form.Group as={Col} controlId="emerContacRelationShip">
                <Row className="align-items-end">
                  <Col sm={ relationShipLoader ? '10': '12' }>
                    <Form.Label className="ml-2">Parentesco</Form.Label>
                    <Form.Control
                      as="select"
                      name="emerContacRelationShip"
                      className="rounded-pill"
                      required
                      defaultValue={ edit ? editItem.parentesco : null }
                      placeholder="Parentesco">
                        {
                          relationShip.map(item => (
                            <option key={item.id} value={item.id}>{item.nombre}</option>
                          ))
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {
                    relationShipLoader && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group>            
            </Row>
            <Form.Group controlId="emerContacAddress">
              <Form.Label className="ml-2">Dirección</Form.Label>
              <Form.Control
                as="textarea"
                name="emerContacAddress"
                required
                defaultValue={ edit ? editItem.direccion : null}
                pattern="[A-Za-z0-9]+"
                placeholder="Dirección"></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite números y letras
              </Form.Control.Feedback>
            </Form.Group> */}
            <Row>
              <Form.Group as={Col} controlId="relativeName">
                <Form.Label className="ml-2">Nombre</Form.Label>
                <Form.Control
                  name="relativeName"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.nombre : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Nombre completo"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="primer_apellido">
                <Form.Label className="ml-2">Primer apellido</Form.Label>
                <Form.Control
                  name="primer_apellido"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.apellido : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Nombre completo"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="segundo_apellido">
                <Form.Label className="ml-2">Segundo apellido</Form.Label>
                <Form.Control
                  name="segundo_apellido"
                  className="rounded-pill"
                  type="text"
                  defaultValue={edit ? editItem.segundo_apellido : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Nombre completo"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="relativeNIdentidad">
                <Form.Label className="ml-2">Identidad</Form.Label>
                <Form.Control
                  name="relativeNIdentidad"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[0-9]{13}"
                  defaultValue={edit ? editItem.identidad : null}
                  placeholder="Identidad"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite una cadena de números de longitud 13
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="relativeGender">
                <Form.Label className="ml-2">Género</Form.Label>
                <Form.Control
                  as="select"
                  name="relativeGender"
                  className="rounded-pill"
                  required
                  defaultValue={edit ? editItem.genero : null}
                  placeholder="Genero">
                    {
                      genero.map(item => (
                        <option key={item.id} value={item.id}>{item.nombre}</option>
                      ))
                    }
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="relativeShip">
                <Row className="align-items-end">
                  <Col sm={ relationShipLoader ? '10': '12' }>
                    <Form.Label className="ml-2">Parentesco</Form.Label>
                    <Form.Control
                      as="select"
                      name="relativeRelationShip"
                      className="rounded-pill"
                      required
                      defaultValue={edit ? editItem.parentesco : null}
                      placeholder="Parentesco">
                        {
                          relationShip.map(item => (
                            <option key={item.id} value={item.id}>{item.nombre}</option>
                          ))
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {
                    relationShipLoader && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="relativeBday">
                <Form.Label className="ml-2">Fecha de nacimiento</Form.Label>
                <Form.Control
                  name="relativeBday"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={edit ? editItem.fecha_nacimiento : null}
                  placeholder="Correo empresarial"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Se requiere un correo valido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="apellidoSolt">
                  <Form.Label className="ml-2">Apellido soltero(a)</Form.Label>
                  <Form.Control
                    name="apellidoSolt"
                    className="rounded-pill"
                    type="text"
                    pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                    defaultValue={edit ? editItem.apellido_soltera : null}
                    placeholder="Apellido soltero(a)"></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="lugarnaci">
                <Form.Label className="ml-2">Ciudad de nacimiento</Form.Label>
                <Form.Control
                  name="lugarnaci"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.ciudad_nacimiento : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ,.0-9\s]+"
                  placeholder="Ciudad de nacimiento"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="countyofbirt">
                <Form.Label className="ml-2">País de nacimiento</Form.Label>
                <Form.Control
                  as="select"
                  name="countyofbirt"
                  className="rounded-pill"
                  required
                  defaultValue={edit ? editItem.pais_nacimiento : null}
                  placeholder="País de nacimiento">
                    {
                      paises.map(item => (
                        <option key={item.code} value={item.code}>{item.name_es}</option>
                      ))
                    }
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Col sm={12} md={6}>
                <Form.Group controlId="cel">
                  <Form.Label className="ml-2">
                    Teléfono
                  </Form.Label>
                  <Form.Control className="rounded-pill"
                    name="cel"
                    type="tel"
                    pattern="[0-9]{8}"
                    required
                    defaultValue={edit ? editItem.telefono : null}
                    placeholder="Teléfono" />
                  <Form.Control.Feedback type="invalid">
                    **Se requiere un número de teléfono valido
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col sm={12} md={6}>
                <Form.Group controlId="obs">
                  <Form.Label className="ml-2">Anotaciones</Form.Label>
                  <Form.Control
                    name="obs"
                    className="rounded-pill"
                    type="text"
                    defaultValue={edit ? editItem.anotaciones : null}
                    pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                    placeholder="Anotaciones"></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {
              props.ect === 1 && (
                <Form.Group controlId="dependentRelativesAddress">
                  <Form.Label className="ml-2">Dirección</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="dependentRelativesAddress"
                    required
                    defaultValue={ edit ? editItem.direccion : null}
                    pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                    placeholder="Dirección"></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid">
                    **Solo admite números y letras
                  </Form.Control.Feedback>
                </Form.Group>
              )
            }
            {/* <Form.Group className="mb-3 ml-2" controlId="esDep">
              <Form.Check defaultChecked={String(editItem.dependiente).toLowerCase() === 'x' ? true : false} name="esDep" type="checkbox" label="Es dependiente económico" />
            </Form.Group> */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveEmergencyContactLoader}  
              variant="primary" 
              type="submit">
                {
                  saveEmergencyContactLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default forwardRef(EmergencyContactsComponent)
